const FWU_PACKAGE_TYPES = {
    SBL: 'SBL',
    BLE_STACK: 'BLE',
};

const fwuPackageTypes = {
    ...FWU_PACKAGE_TYPES,
    isSbl: (packageType) => packageType === FWU_PACKAGE_TYPES.SBL,
    isBleStack: (packageType) => packageType === FWU_PACKAGE_TYPES.BLE_STACK,
};

export default fwuPackageTypes;
